/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type LeafletMapLineServiceConfigQueryVariables = Types.Exact<{
  serviceAreaId: Types.Scalars['ID']['input']
}>

export type LeafletMapLineServiceConfigQuery = {
  __typename?: 'Query'
  lineServiceConfig: {
    __typename?: 'LineServiceConfig'
    enabled: boolean
    serviceAreaId: string
  }
}

export const LeafletMapLineServiceConfigDocument = gql`
    query leafletMapLineServiceConfig($serviceAreaId: ID!) {
  lineServiceConfig(serviceAreaId: $serviceAreaId) {
    enabled
    serviceAreaId
  }
}
    `

/**
 * __useLeafletMapLineServiceConfigQuery__
 *
 * To run a query within a React component, call `useLeafletMapLineServiceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeafletMapLineServiceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeafletMapLineServiceConfigQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useLeafletMapLineServiceConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  > &
    (
      | { variables: LeafletMapLineServiceConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  >(LeafletMapLineServiceConfigDocument, options)
}
export function useLeafletMapLineServiceConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  >(LeafletMapLineServiceConfigDocument, options)
}
// @ts-ignore
export function useLeafletMapLineServiceConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LeafletMapLineServiceConfigQuery,
  LeafletMapLineServiceConfigQueryVariables
>
export function useLeafletMapLineServiceConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeafletMapLineServiceConfigQuery,
        LeafletMapLineServiceConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LeafletMapLineServiceConfigQuery | undefined,
  LeafletMapLineServiceConfigQueryVariables
>
export function useLeafletMapLineServiceConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LeafletMapLineServiceConfigQuery,
        LeafletMapLineServiceConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LeafletMapLineServiceConfigQuery,
    LeafletMapLineServiceConfigQueryVariables
  >(LeafletMapLineServiceConfigDocument, options)
}
export type LeafletMapLineServiceConfigQueryHookResult = ReturnType<
  typeof useLeafletMapLineServiceConfigQuery
>
export type LeafletMapLineServiceConfigLazyQueryHookResult = ReturnType<
  typeof useLeafletMapLineServiceConfigLazyQuery
>
export type LeafletMapLineServiceConfigSuspenseQueryHookResult = ReturnType<
  typeof useLeafletMapLineServiceConfigSuspenseQuery
>
export type LeafletMapLineServiceConfigQueryResult = Apollo.QueryResult<
  LeafletMapLineServiceConfigQuery,
  LeafletMapLineServiceConfigQueryVariables
>
